import React from 'react';

function NumpadSubmitButton({ setIsNumpadActive }) {
  return (
    <button className='numpad-btn-accept' onClick={() => setIsNumpadActive(false)}>
      OK
    </button>
  );
}

export default NumpadSubmitButton;
